import React from 'react';
import WebhooksSettings from '../features/settings/webhooks/WebhooksSettings';

const WebhooksSettingsPage: React.FC = () => {
    return <WebhooksSettings />;
};

export default WebhooksSettingsPage;
